import React, { useMemo, useState } from 'react'
import { Container, Row, Col, Form, Button, Alert } from 'react-bootstrap'
import axios from 'axios'

function ContactScreen() {
  const [form, setForm] = useState({
    first_name: '',
    last_name: '',
    email: '',
    phone: '',
    product: '',
    message: '',
  })
  const [submitting, setSubmitting] = useState(false)
  const [error, setError] = useState('')
  const [success, setSuccess] = useState(false)

  const emailValid = useMemo(() => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email || ''), [form.email])
  const phoneValid = useMemo(() => {
    if (!form.phone) return true
    return /^[0-9+\-\s()]{6,}$/.test(form.phone)
  }, [form.phone])
  const isValid = (form.first_name && form.first_name.trim().length > 0)
    && (form.last_name && form.last_name.trim().length > 0)
    && (form.message && form.message.trim().length > 0)
    && emailValid

  const handleChange = (e) => {
    const { name, value } = e.target
    setForm(prev => ({ ...prev, [name]: value }))
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    setSubmitting(true)
    setError('')
    setSuccess(false)
    try {
      await axios.post('/api/contact/', form)
      setSuccess(true)
      setForm({
        first_name: '',
        last_name: '',
        email: '',
        phone: '',
        product: '',
        message: '',
      })
    } catch (err) {
      setError(err?.response?.data?.detail || 'Failed to send your message. Please try again.')
    } finally {
      setSubmitting(false)
    }
  }

  return (
    <Container className="py-4">
      <Row className="g-4">
        <Col md={5}>
          <div className="ws-card" style={{padding:'20px'}}>
            <h2 className="ws-section-title">Contact Us</h2>
            <p className="ws-muted">Send a message and our team will get back to you shortly.</p>
            <div className="mt-3">
              <div className="ws-muted">Customer Care</div>
              <div style={{fontWeight:700, color:'var(--ws-color-text)'}}>support@wigsnstuff.com</div>
            </div>
            <div className="mt-2">
              <div className="ws-muted">Hours</div>
              <div style={{color:'var(--ws-color-text)'}}>Mon–Fri, 9:00–17:00</div>
            </div>
          </div>
        </Col>
        <Col md={7}>
          <div className="ws-card" style={{padding:'20px'}}>
            {success && <Alert variant="success">Thanks! Your message was sent.</Alert>}
            {error && <Alert variant="danger">{error}</Alert>}
            <Form onSubmit={handleSubmit} noValidate>
              <Row>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label className="ws-required">First name</Form.Label>
                    <Form.Control name="first_name" value={form.first_name} onChange={handleChange} required />
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label className="ws-required">Last name</Form.Label>
                    <Form.Control name="last_name" value={form.last_name} onChange={handleChange} required />
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label className="ws-required">Email</Form.Label>
                    <Form.Control
                      type="email"
                      name="email"
                      value={form.email}
                      onChange={handleChange}
                      isInvalid={form.email !== '' && !emailValid}
                    />
                    <Form.Control.Feedback type="invalid">Enter a valid email.</Form.Control.Feedback>
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Phone</Form.Label>
                    <Form.Control
                      name="phone"
                      value={form.phone}
                      onChange={handleChange}
                      isInvalid={!!form.phone && !phoneValid}
                    />
                    <Form.Control.Feedback type="invalid">Enter a valid phone number.</Form.Control.Feedback>
                  </Form.Group>
                </Col>
              </Row>
              <div className="mb-2 ws-muted" style={{fontSize:13}}>Phone is optional.</div>
              <Form.Group className="mb-3">
                <Form.Label>Product (optional)</Form.Label>
                <Form.Control name="product" value={form.product} onChange={handleChange} />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label className="ws-required">Message</Form.Label>
                <Form.Control as="textarea" rows={5} name="message" value={form.message} onChange={handleChange} required />
              </Form.Group>
              <Button type="submit" className="ws-btn ws-btn-primary" disabled={submitting || !isValid}>
                {submitting ? 'Sending...' : 'Send Message'}
              </Button>
            </Form>
          </div>
        </Col>
      </Row>
    </Container>
  )
}

export default ContactScreen


